import { reject, resolve } from './core/actions';
/** Owns physical requests. State is already invalidated whenever sync aborts an old request. */
export class TimeListDriver {
    adapter;
    transport;
    dispatch;
    now;
    #active = null;
    constructor(adapter, transport, dispatch, now) {
        this.adapter = adapter;
        this.transport = transport;
        this.dispatch = dispatch;
        this.now = now;
    }
    sync(state) {
        const fetch = state.fetch;
        const requestId = fetch.status === 'in-flight' ? fetch.ticket.requestId : null;
        if (this.#active?.requestId === requestId)
            return;
        const previous = this.#active;
        this.#active = null;
        previous?.controller.abort();
        if (fetch.status !== 'in-flight')
            return;
        const controller = new AbortController();
        this.#active = { requestId: fetch.ticket.requestId, controller };
        // Starting transport is synchronous; even synchronous adapter/port throws become ticketed failures.
        void this.#execute(fetch, controller);
    }
    async #execute(fetch, controller) {
        try {
            const request = this.adapter.toRequest(fetch.instruction);
            const raw = await this.transport.execute({ ticket: fetch.ticket, request }, controller.signal);
            if (controller.signal.aborted)
                return;
            if (raw === undefined)
                throw new Error('Transport resolved without a response');
            const result = this.adapter.fromResponse(fetch.instruction, raw);
            this.dispatch(resolve(fetch.ticket, result, this.now()));
        }
        catch (error) {
            this.dispatch(reject(fetch.ticket, error));
        }
    }
}
//# sourceMappingURL=driver.js.map